import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

function Signup() {
const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    role: "Admin",
    password: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
	"https://api.crm.dsdesigncode.com/api/register/",
        formData
      );
      alert("Registration Successful!");
      console.log(response.data);
    } catch (error) {
      console.error(error.response.data);
      alert("Error in Registration");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">

      <div className="w-full max-w-md bg-white p-10 rounded-xl shadow-sm">

        <img
          src="/images/logo.png"
          className="m-auto mb-20"
          alt="logo"
          width={200}
        />

<form onSubmit={handleSubmit}>

        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium">
            First Name
          </label>
          <input
            type="text" name="firstname" onChange={handleChange}
            className="border w-full h-10 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
          />
        </div>

        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium">
            Last Name
          </label>
          <input
            type="text" name="lastname" onChange={handleChange}
            className="border w-full h-10 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
          />
        </div>

        {/* Email */}
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium">
            Email Address
          </label>
          <input
            type="email" name="email" onChange={handleChange}
            className="border w-full h-10 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
          />
        </div>

        {/* Password */}
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium">
            Password
          </label>
          <input
            type="password" name="password" onChange={handleChange}
            className="border w-full h-10 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
          />
        </div>

        {/* Register Button */}
        <button className="bg-black text-white p-2 w-full rounded-md mb-3">
          Sign Up
        </button>
</form>
        {/* Google Signup */}
        <button className="bg-white border p-2 w-full rounded-md mb-4">
          Sign Up with Gmail
        </button>

        {/* Login Link */}
        <div className="text-center text-sm">
          Already have an account?
          <Link to="/login" className="ml-2 font-semibold">
            Login
          </Link>
        </div>

      </div>
    </div>
  );
}

export default Signup;
